const EDIT_ANIMAL_DRAFT_PREFIX = 'admin:animalDraft:edit:'
const EDIT_ANIMAL_PACKAGE_DRAFT_PREFIX = 'admin:animalPackageDraft:edit:'
export const NEW_ANIMAL_DRAFT_KEY = 'admin:animalDraft:new'
export const NEW_ANIMAL_PACKAGE_DRAFT_KEY = 'admin:animalPackageDraft:new'
export const ANIMAL_IMAGE_FILE_ACCEPT = 'image/png, image/jpeg, image/jpg'
export const ANIMAL_IMAGE_FILE_ERROR_MESSAGE = 'png, jpg, jpeg 파일만 업로드 가능합니다.'

// 애니멀런 이미지는 기존 운영 기준인 PNG/JPG/JPEG 파일만 통과시킨다.
export const isAnimalImageFile = (file) => {
    return Boolean(file) && (
        (file.type && ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) ||
        /\.(png|jpe?g)$/i.test(file.name || '')
    )
}

const ANIMAL_DRAFT_FIELDS = [
    'meetType',
    'meetType2',
    'title',
    'country',
    'area',
    'address',
    'addressDetail',
    'startTime',
    'endTime',
    'info1',
    'info2',
    'info3',
    'info4',
    'info5',
    'info6',
    'info7',
    'paymentStatus',
    'couponStatus',
    'visibleStatus',
    'shippingPolicyType',
    'shippingPrice',
    'basicLike',
    'rStatus',
    'sStatus',
    'sOptionName',
    'sOptionPrice',
    'sOptionQuantity',
    'isShow',
    'isAnimalPackage',
    'packageCode',
    'progressPackageCode',
    'requiredAreaM2',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const serializeDateValue = (value) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return ''
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? '' : nextDate.toISOString()
}

const parseDateValue = (value, fallbackValue) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return fallbackValue
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallbackValue : nextDate
}

const normalizeCategoryItem = (item = {}, index = 0) => {
    return {
        ...item,
        id: item.id ?? index,
        type: item.type ?? 2,
        distance: item.distance ?? 0,
        price: item.price ?? 0,
        name: item.name || '',
        quantity: item.quantity ?? 0,
        status: item.status ?? 0,
        order: item.order ?? index,
    }
}

const normalizeSelectionOptionItem = (item = {}, index = 0) => {
    return {
        ...item,
        id: item.id ?? item.productCategoryId ?? index,
        type: item.type ?? 2,
        distance: item.distance ?? 0,
        price: item.price ?? 0,
        name: item.name || '',
        quantity: item.quantity ?? 0,
        status: 1,
        order: item.order ?? index,
        webVisible: item.webVisible ?? 1,
        appVisible: item.appVisible ?? 0,
    }
}

export const normalizeAnimalSelectionOption = normalizeSelectionOptionItem

export const createDefaultSelectionOption = (index = 0) => normalizeSelectionOptionItem({
    name: index === 0 ? '우드케이스' : '',
    price: index === 0 ? 11000 : 0,
    quantity: index === 0 ? 999 : 0,
    appVisible: index === 0 ? 1 : 0,
    webVisible: 1,
    order: index,
}, index)

const normalizeOptionItem = (item = {}, index = 0) => {
    return {
        ...item,
        id: item.id ?? index,
        name: item.name || '',
        quantity: item.quantity ?? 0,
    }
}

const createFallbackSelectionOptions = (data = {}) => {
    if (!data.sOptionName && data.sOptionPrice === undefined && data.sOptionQuantity === undefined) {
        return []
    }

    return [normalizeSelectionOptionItem({
        name: data.sOptionName || '우드케이스',
        price: data.sOptionPrice ?? 11000,
        quantity: data.sOptionQuantity ?? 999,
        webVisible: data.sOptionWebVisible ?? 1,
        appVisible: data.sOptionAppVisible ?? 1,
    })]
}

const mergeSelectionOptionsWithServer = (draftSelectionOptions = [], baseSelectionOptions = []) => {
    const normalizedDraftOptions = Array.isArray(draftSelectionOptions)
        ? draftSelectionOptions.map(normalizeSelectionOptionItem)
        : []
    const normalizedBaseOptions = Array.isArray(baseSelectionOptions)
        ? baseSelectionOptions.map(normalizeSelectionOptionItem)
        : []
    const missingBaseOptions = normalizedBaseOptions.filter((baseItem) => {
        const baseName = String(baseItem.name || '').trim()

        return !normalizedDraftOptions.some((draftItem) => {
            if (baseItem.productCategoryId && draftItem.productCategoryId) {
                return Number(baseItem.productCategoryId) === Number(draftItem.productCategoryId)
            }

            return baseName && baseName === String(draftItem.name || '').trim()
        })
    })

    return [...normalizedDraftOptions, ...missingBaseOptions]
}

// 애니멀런 폼에서 실제로 수정하는 값만 sessionStorage에 남긴다.
export const createAnimalDraftPayload = ({ data = {}, arr = [], options = [], selectionOptions, beginDay, finishDay }) => {
    return {
        data: {
            meetType: data.meetType,
            meetType2: data.meetType2,
            title: data.title || '',
            country: data.country || '',
            area: data.area || '',
            address: data.address || '',
            addressDetail: data.addressDetail || '',
            startTime: serializeDateValue(data.startTime),
            endTime: serializeDateValue(data.endTime),
            info1: data.info1 || '',
            info2: data.info2 || '',
            info3: data.info3 || '',
            info4: data.info4 || '',
            info5: data.info5 || '',
            info6: data.info6 || '',
            info7: data.info7 || '',
            paymentStatus: data.paymentStatus,
            couponStatus: data.couponStatus,
            visibleStatus: data.visibleStatus,
            shippingPolicyType: data.shippingPolicyType,
            shippingPrice: data.shippingPrice,
            basicLike: data.basicLike,
            rStatus: data.rStatus,
            sStatus: data.sStatus,
            sOptionName: data.sOptionName || '',
            sOptionPrice: data.sOptionPrice ?? '',
            sOptionQuantity: data.sOptionQuantity ?? '',
            isShow: data.isShow,
            isAnimalPackage: data.isAnimalPackage,
            packageCode: data.packageCode || '',
            progressPackageCode: data.progressPackageCode || '',
            requiredAreaM2: data.requiredAreaM2 ?? '',
        },
        arr: Array.isArray(arr) ? arr.map(normalizeCategoryItem) : [],
        options: Array.isArray(options) ? options.map(normalizeOptionItem) : [],
        selectionOptions: Array.isArray(selectionOptions) ? selectionOptions.map(normalizeSelectionOptionItem) : createFallbackSelectionOptions(data),
        beginDay: serializeDateValue(beginDay),
        finishDay: serializeDateValue(finishDay),
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 입력 흐름을 이어간다.
export const applyAnimalDraft = ({
    baseData = {},
    baseArr = [],
    baseOptions = [],
    baseSelectionOptions = [],
    beginDay,
    finishDay,
    draft,
}) => {
    if (!draft) {
        return {
            data: baseData,
            arr: baseArr,
            options: baseOptions,
            selectionOptions: Array.isArray(baseSelectionOptions) ? baseSelectionOptions.map(normalizeSelectionOptionItem) : createFallbackSelectionOptions(baseData),
            beginDay,
            finishDay,
        }
    }

    const draftData = draft.data || {}
    const hasLegacySelectionOptionDraft = (
        draftData.sOptionName !== undefined ||
        draftData.sOptionPrice !== undefined ||
        draftData.sOptionQuantity !== undefined
    )
    const nextData = {
        ...baseData,
    }

    ANIMAL_DRAFT_FIELDS.forEach((field) => {
        if (draftData[field] === undefined) {
            return
        }

        if (field === 'startTime' || field === 'endTime') {
            nextData[field] = parseDateValue(draftData[field], baseData[field] ?? null)
            return
        }

        nextData[field] = draftData[field]
    })

    const nextSelectionOptions = (() => {
        if (Array.isArray(draft.selectionOptions)) {
            return mergeSelectionOptionsWithServer(draft.selectionOptions, baseSelectionOptions)
        }

        if (hasLegacySelectionOptionDraft) {
            return createFallbackSelectionOptions(nextData)
        }

        if (Array.isArray(baseSelectionOptions) && baseSelectionOptions.length > 0) {
            return baseSelectionOptions.map(normalizeSelectionOptionItem)
        }

        return createFallbackSelectionOptions(nextData)
    })()

    return {
        data: nextData,
        arr: Array.isArray(draft.arr) ? draft.arr.map(normalizeCategoryItem) : baseArr,
        options: Array.isArray(draft.options) ? draft.options.map(normalizeOptionItem) : baseOptions,
        selectionOptions: nextSelectionOptions,
        beginDay: parseDateValue(draft.beginDay, beginDay),
        finishDay: parseDateValue(draft.finishDay, finishDay),
    }
}

export const createEditAnimalDraftKey = (productId) => `${EDIT_ANIMAL_DRAFT_PREFIX}${productId}`
export const createEditAnimalPackageDraftKey = (productId) => `${EDIT_ANIMAL_PACKAGE_DRAFT_PREFIX}${productId}`

export const readAnimalDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAnimalDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 입력 흐름은 그대로 유지한다.
    }
}

export const clearAnimalDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
